import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  choosePlanWrapper: {
    height: '100%',
  },
  periodButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  plansWrapper: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: theme.spacing(2),
    alignItems: 'stretch',
    padding: theme.spacing(2, 1),
    boxSizing: 'border-box',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      flexWrap: 'nowrap',
      gap: theme.spacing(2),
      height: 'calc(100% - 40px)',
    },
  },
}));
